// api/hook/useRegistration.ts
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import apiClient from "../config";

interface CourseRegistrationProps {
  courseId: string;
  memberNo: string;
  token: string;
}

const registerForCourse = async ({
  courseId,
  memberNo,
  token,
}: CourseRegistrationProps) => {
  const { data } = await apiClient.post(
    `/student/chooseCourse/${courseId}/${memberNo}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return data;
};

export const useCourseRegistration = () => {
  return useMutation({
    mutationFn: registerForCourse,
    onSuccess: (data) => {
      const message =
        typeof data === "string"
          ? data
          : data?.message || data?.data || "Successfully enrolled in course!";
      toast.success(message);
    },
    onError: (error: any) => {
      if (error.response?.status === 403) return;

      const errorData = error.response?.data;
      const errorMessage =
        typeof errorData === "string" ? errorData : errorData?.message || "";

      if (errorMessage.toLowerCase().includes("already registered")) {
        // treated as success — handled in enrollAfterAuth
        return;
      }

      toast.error(
        errorMessage || "Failed to enroll in course. Please try again.",
      );
    },
  });
};
